import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as  R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { orders } from '../../../../../../redux/orders/action';
import ShipmentComponent from '../components/shipment.component';
import { selectTransportersListItems } from '../../../../../../redux/transporters/selector';
import { agents } from '../../../../../../redux/agents/action';
import { selectOrdersQueryItems } from '../../../../../../redux/orders/selector';
import PageLoader from '../../../../../../components/PageLoader';
import { selectAgentsListItems } from '../../../../../../redux/agents/selector';
import { transporters } from '../../../../../../redux/transporters/action';


const ManagementOrder = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const orderQuery = useSelector(selectOrdersQueryItems)
  const transporterListItems = useSelector(selectTransportersListItems)
  const transportAgentListItems = useSelector(selectAgentsListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const [
    selectShipping,
    setSelectShipping
  ] = useState<any>({})


  const fetchorderById = () => {
    dispatch(orders.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/query`, entity: 'orders', jsonData: {


        Records: [
          {
            context: {},
            Message: {
              Id: parmas?.id
            }
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }
  const handleInnerFormChange = (event: any, field: string) => {
    setSelectShipping({ ...selectShipping, [field]: event });
  }

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },

      { field: 'ItemName', headerName: 'Item Name' },
      { field: 'Quantity', headerName: 'Quantity' },
    ]);
  }
  const getTransportersName = (transporterId: any) => {
    const TransporterName = R.find(
      (transporter: any) => parseInt(
        transporter.Id,
        10
      ) === parseInt(
        transporterId,
        10
      ),
      transporterListItems.result.items
    )
    return TransporterName ? TransporterName.Name : ''
  }
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(orders.resetAction({ actionType: 'update' }))
      await dispatch(orders.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments`, entity: 'orders', jsonData: {


          Records: [
            {
              context: {},
              Message: selectShipping
            }
          ]

        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(orders.resetAction({ actionType: 'create' }))
      await dispatch(orders.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments`, entity: 'orders', jsonData: {
          Records: [
            {
              context: {},
              Message: selectShipping
            }
          ]

        }
      })).then(() => {
        back()
      })
    }

  }

  useEffect(
    () => {
      dispatch(transporters.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transporters/list`, entity: 'transporters', jsonData: {

        }
      })).then(() => {
        dispatch(agents.list({
          url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/list`, entity: 'agents', jsonData: {

          }
        }))
      }).then(() => {
        if (parmas?.id > 0) {
          createColumnDefs()
          fetchorderById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectShipping(orderQuery?.result?.items?.Message)
      }
    },
    [isQuery]
  )


  const back = () => {
    navigate('/management/logistics/transport/shipments')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <ShipmentComponent
          rowData={selectShipping?.ShipmentItems}
          columnDefs={columnDefs}
          selectShipping={selectShipping}
          getTransportersName={getTransportersName}
          handleInnerFormChange={handleInnerFormChange}
          transportAgents={transportAgentListItems.result.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementOrder;